export const getURLMetaData = (titleKey, options = {}) => {
  return Object.assign({}, { title: titleKey }, options);
};
